import { useQuery } from '@tanstack/react-query';

import { getUserAssignments } from '../data-access/getUserAssignments';

export const useUserAssignments = (userId: string) =>
  useQuery({
    queryKey: ['user-assignments', userId],
    queryFn: () => getUserAssignments(userId),
  });
